module.exports = __webpack_public_path__ + "static/media/3.bf3391ac.jpg";